import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue'
    import { Size } from './basic_button/size'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'basic_button',
  props: {
        disabled: {
            type: Boolean as PropType<boolean>,
            default() {
                return false
            }
        },
        size: {
            type: String as PropType<Size>,
            default() {
                return Size.normal
            }
        }
    },
  emits: ['click'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

    const props = __props

    const emit = __emit
    const disabled = computed(() => props.disabled)
    const size = computed(() => props.size)
    let classes = [
        'disabled:border-gray-200',
        'disabled:bg-gray-50',
        'disabled:text-gray-200',
        'flex',
        'w-full',
        'items-center',
        'justify-center',
        'gap-1',
        'rounded-full',
        'border',
        'border-gray-300',
        'bg-white',
        'text-sm',
        'font-medium',
        'text-gray-700',
        'shadow-theme-xs',
        'hover:bg-gray-50',
        'hover:text-gray-800',
        'dark:border-gray-700',
        'dark:bg-gray-800',
        'dark:text-gray-400',
        'dark:hover:bg-white/[0.03]',
        'dark:hover:text-gray-200',
        'lg:inline-flex',
    ]

    if (size.value === Size.small) {
        classes.push('px-1', 'py-1')
    } else if (size.value === Size.large) {
        classes.push('px-3', 'py-3')
    } else {
        classes.push('px-2', 'py-2')
    }

    function clicked(event: MouseEvent) {
        emit('click', event)
    }

const __returned__ = { props, emit, disabled, size, get classes() { return classes }, set classes(v) { classes = v }, clicked }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})